import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { ILoadingOrderPallet, IRelatedDocument } from "model";
import { IPaginateApiResponse } from "model/Common/IPaginateApiResponse";
import { IDeliveryProgress } from "model/LoadingOrder/IDeliveryProgress";
import { ILoadingOrder } from "model/LoadingOrder/ILoadingOrder";
import { ILoadingOrderProduct } from "model/LoadingOrder/ILoadingOrderProduct";
import { LoadingOrderActions } from "redux/actions";
import { AnyAction } from "redux";
interface IBaseLoadingOrder<T> {
  data?: IPaginateApiResponse<T>;
  action: string;
}
interface ILoadingOrderState extends IBaseReducerState {
  loadingOrder?: IPaginateApiResponse<ILoadingOrder[]>;
  product: IBaseLoadingOrder<ILoadingOrderProduct[]>;
  pallet: IBaseLoadingOrder<ILoadingOrderPallet[]>;
  deliveryProgress: IBaseLoadingOrder<IDeliveryProgress[]>;
  relatedDocument: IBaseLoadingOrder<IRelatedDocument[]>;
}

const initialState: ILoadingOrderState = {
  action: LoadingOrderActions.prefix,
  prefix: LoadingOrderActions.prefix,
  product: {
    action: "PRODUCTS",
  },
  pallet: {
    action: "PALLETS",
  },
  deliveryProgress: {
    action: "DELIVERY_PROGRESS",
  },
  relatedDocument: {
    action: "RELATED_DOCUMENTS",
  },
};

const getAllLoadingOrderSuccess = (
  state: ILoadingOrderState,
  action: PayloadAction<IPaginateApiResponse<ILoadingOrder[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.loadingOrder = action.payload;
  });
const getAllLoadingOrderProductsSuccess = (
  state: ILoadingOrderState,
  action: PayloadAction<IPaginateApiResponse<ILoadingOrderProduct[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.product.data = action.payload;
    state.product.action = action.type;
  });
const getAllLoadingOrderPalletsSuccess = (
  state: ILoadingOrderState,
  action: PayloadAction<IPaginateApiResponse<ILoadingOrderPallet[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.pallet.data = action.payload;
    state.pallet.action = action.type;
  });
const getDeliveryProgressSuccess = (
  state: ILoadingOrderState,
  action: PayloadAction<IPaginateApiResponse<IDeliveryProgress[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.deliveryProgress.data = action.payload;
    state.deliveryProgress.action = action.type;
  });

const getRelatedDocumentsSuccess = (
  state: ILoadingOrderState,
  action: PayloadAction<IPaginateApiResponse<IRelatedDocument[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.relatedDocument.data = action.payload;
    state.relatedDocument.action = action.type;
  });

const LoadingOrderReducer = ReduxHelper.createHandleReducer(
  initialState,
  (builder) => {
    builder
      .addCase(
        LoadingOrderActions.getAllLoadingOrder.success,
        getAllLoadingOrderSuccess
      )
      .addCase(
        LoadingOrderActions.getAllLoadingOrderProducts.success,
        getAllLoadingOrderProductsSuccess
      )
      .addCase(
        LoadingOrderActions.getAllLoadingOrderPallets.success,
        getAllLoadingOrderPalletsSuccess
      )
      .addCase(
        LoadingOrderActions.getDeliveryProgress.success,
        getDeliveryProgressSuccess
      )
      .addCase(
        LoadingOrderActions.getRelatedDocuments.success,
        getRelatedDocumentsSuccess
      );
  },
  (state: ILoadingOrderState, action: AnyAction) => {
    const watcherAction = action.type;
    if (watcherAction?.includes("PRODUCTS")) {
      state.product.action = action.type;
    }
    if (watcherAction?.includes("PALLETS")) {
      state.pallet.action = action.type;
    }
    if (watcherAction?.includes("DELIVERY_PROGRESS")) {
      state.deliveryProgress.action = action.type;
    }
    if (watcherAction?.includes("RELATED_DOCUMENTS")) {
      state.relatedDocument.action = action.type;
    }
  }
);

export default LoadingOrderReducer;
